export const eventServicesList = {
  documentsList: 'documentsList',
  documentVersionsList: 'documentVersionsList',
  baselineDocumentsList: 'baselineDocumentsList',
  playbooksList: 'playbooksList',
  playbookDetailsAssociatedClausesList: 'playbookDetailsAssociatedClausesList',
  clausesList: 'clausesList',
  metadataList: 'metadataList',
  questionsList: 'questionsList',
  docTypesList: 'docTypesList',
  counterpartiesList: 'counterpartiesList',
  workspacesList: 'workspacesList',
  workspaceDocumentsList: 'workspaceDocumentsList',
};
